var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("footer " + _vm.$device)},[_vm._v("2020 中國移動香港有限公司版權所有")])}
var staticRenderFns = []
export { render, staticRenderFns }